(ns practitest.frontend.global-fields-settings.main
  (:require [practitest.frontend.components2.spinners :as spinners]
            [practitest.frontend.global-fields-settings.views :as views]
            [practitest.frontend.global-fields-settings.events :as events]
            [practitest.frontend.common-old-fe.i18n :as i18n]
            [re-frame.core :as re-frame]
            [re-frame.db]))

(defn global-fields-settings-view []
  (if-let [_init-done? @(re-frame/subscribe [:global-fields-settings/init-complete?])]
    [views/main-panel]
    [:div.loader
     [spinners/mux-spinner {:size :modal}]]))

(defn new []
  [views/global-field-form-page {:edit? false}])

(defn edit []
  [views/global-field-form-page {:edit? true}])

(defn ^:export legacy-init [config translation]
  (i18n/initialize (js->clj translation :keywordize-keys true))
  (re-frame/dispatch [:global-fields-settings/initialize (js->clj config :keywordize-keys true)])
  (re-frame/dispatch [:global-fields-settings/init-complete]))

(defn form-controller []
  {:stop (fn [_] (re-frame/dispatch [::events/reset-form-values]))})